<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input clearable v-model="listQuery.title" :placeholder="$t('publicAccountAd.title')" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        {{ $t('table.search') }}
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">
        {{ $t('table.add') }}
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" prop="id" sortable="custom" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccount.publicAccountName')" align="center" min-width="180px">
        <template slot-scope="scope">
          <span>{{ scope.row.account_name }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.newsTitle')" align="center" min-width="180px">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccount.coverPicture')" align="center" width="150px">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="$publicData.imgUrl + scope.row.cover"
            :preview-src-list="[$publicData.imgUrl + scope.row.cover]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.publishTime')" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.publish_time }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.likeNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.like_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.collectNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.collect_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.commentNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.comment_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.status')" align="center" width="100px">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2"
            @change="statusChange($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.sort')" align="center" width="200px">
        <template slot-scope="scope">
          <el-input-number size="small" v-model="scope.row.sort_index" @change="setSort($event, $event, scope.row)" :min="0"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.actions')" fixed="right" align="center" width="120" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            {{ $t('table.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <el-dialog :title="textMap" :visible.sync="dialogFormVisible" width="80%">
      <el-table
        ref="newsTable"
        :key="tableKey1"
        v-loading="listLoading2"
        :data="newsList"
        border
        fit
        highlight-current-row
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50px">
        </el-table-column>
        <el-table-column :label="$t('table.id')" align="center" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccount.publicAccountName')" align="center" min-width="180px">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccountNews.newsTitle')" align="center" min-width="250px">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccount.coverPicture')" align="center" width="150px">
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="$publicData.imgUrl + scope.row.cover"
              :preview-src-list="[$publicData.imgUrl + scope.row.cover]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccountNews.publishTime')" align="center" width="150px">
          <template slot-scope="scope">
            <span>{{ scope.row.publish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccountNews.likeNum')" align="center" width="170px">
          <template slot-scope="scope">
            <span>{{ scope.row.like_num }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccountNews.collectNum')" align="center" width="170px">
          <template slot-scope="scope">
            <span>{{ scope.row.collect_num }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('publicAccountNews.commentNum')" align="center" width="170px">
          <template slot-scope="scope">
            <span>{{ scope.row.comment_num }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="newsTotal>0" :total="newsTotal" :page.sync="newsListQuery.page" :limit.sync="newsListQuery.limit" @pagination="getNewsList" />

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          {{ $t('table.cancel') }}
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          {{ $t('table.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, createPublicAccountAd, delPublicAccountAd, editStatus, editSort } from '@/api/publicAccountAd'
import { fetchList as fetchNewsList } from '@/api/publicAccountNews'
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination

export default {
  name: 'AdvertPublicAccount',
  components: { Pagination },
  directives: { waves },
  data() {
    return {
      tableKey: 0,
      tableKey1: 1,
      list: null,
      total: 0,
      newsTotal: 0,
      listLoading: true,
      listLoading2: true,
      listQuery: {
        page: 1,
        limit: 20,
        title: undefined,
        id_sort: 'desc'
      },
      newsListQuery: {
        page: 1,
        limit: 10,
        id_sort: 'desc',
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      newsList: null,
      selectNewsData: []
    }
  },
  computed: {
    textMap: function() {
      return this.dialogStatus === 'update' ? this.$t('form.edit') : this.$t('form.create')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleSelectionChange(val) {
      var ids = []
      val.forEach(function(item, index) {
        ids.push(item.id)
      })
      this.selectNewsData = ids
    },
    setSort(currentValue, oldValue, row) {
      editSort({ id: row.id, sort_index: currentValue }).then((res) => {
        if (res.code === 20000) {
          this.$message.success(this.$t('form.updateSuccess'))
        }
      })
    },
    getList() {
      this.listLoading = true
      fetchList(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      if (prop === 'id') {
        this.sortByID(order)
      }
    },
    sortByID(order) {
      if (order === 'ascending') {
        this.listQuery.id_sort = 'asc'
      } else {
        this.listQuery.id_sort = 'desc'
      }
      this.handleFilter()
    },
    resetTemp() {
      this.selectNewsData = []
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['newsTable'].clearSelection()
      })
      this.newsListQuery.page = 1
      this.getNewsList()
    },
    getNewsList() {
      this.listLoading2 = true
      fetchNewsList(this.newsListQuery).then((res) => {
        if (res.code === 20000) {
          this.newsList = res.data.list
          this.newsTotal = res.data.total
          this.listLoading2 = false
        }
      })
    },
    createData() {
      if (this.selectNewsData.length <= 0) {
        this.$message.warning(this.$t('publicAccountAd.pleaseSelectNews'))
        return false
      }
      createPublicAccountAd({ news_ids: this.selectNewsData }).then((res) => {
        if (res.code === 20000) {
          this.dialogFormVisible = false
          this.$message.success(this.$t('form.createSuccess'))
          this.handleFilter()
        }
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPublicAccountAd({ id: row.id }).then((res) => {
          if (res.code === 20000) {
            this.$message.success(this.$t('form.delSuccess'))
            this.handleFilter()
          }
        })
      }).catch(() => {
      })
    },
    statusChange(val, row) {
      editStatus({ id: row.id, status: val }).then((res) => {
        if (res.code === 20000) {
          this.$message.success(this.$t('form.updateSuccess'))
        }
      })
    }
  }
}
</script>
